
export const ContainerCardsAreasPie = ({ datas = [] }) => {
	return (
		<div className="w-full max-w-[440px] grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-4 ">
            {datas.map(({ label, value, color, extra }, key) => {
				return (
					<article key={`${key}--area-section`} className="p-4 rounded-md bg-[#EFF2F5] flex flex-col gap-2">
						<header className="flex justify-start gap-3">
							<div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }} />
							<p className="text-xs font-bold">{label}</p>
						</header>
						<main className="flex justify-between items-center gap-2">
							<p className="font-bold text-base">
								{value} <span className="text-xs">horas</span>
							</p>
                            <p className="font-bold text-base">{extra?.percentage}%</p>
						</main>
					</article>
				);
			})}
		</div>
	);
};
